import { ProxyFormComponent } from '@theme/proxy-form';

const RECOMMENDATION_LIMIT = 3;

class OutOfStockButtonsComponent extends ProxyFormComponent {
  get #dialog() {
    return this.querySelector('dialog-component');
  }

  get #formState() {
    return this.querySelector('[data-role="form-state"]');
  }

  get #successState() {
    return this.querySelector('[data-role="success-state"]');
  }

  openDrawer() {
    this.#resetState();
    this.#dialog?.showDialog();
  }

  closeDialog() {
    this.#dialog?.closeDialog();
  }

  scrollToRecs() {
    const recommendations =
      document.querySelector('product-recommendations[data-intent="related"]') ||
      document.querySelector('product-recommendations');

    recommendations?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  #recommendationIds() {
    const recommendations =
      document.querySelector('product-recommendations[data-intent="related"]') ||
      document.querySelector('product-recommendations');

    if (!recommendations) return [];

    const ids = [];

    for (const element of recommendations.querySelectorAll('[data-product-id]')) {
      const id = element.dataset.productId;
      if (id && !ids.includes(id)) ids.push(id);
      if (ids.length === RECOMMENDATION_LIMIT) break;
    }

    return ids;
  }

  async handleSubmit(event) {
    event.preventDefault();

    const form = event.target.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    formData.delete('recommendationProductIds');
    formData.delete('recommendationProductIds[]');
    for (const id of this.#recommendationIds()) {
      formData.append('recommendationProductIds[]', id);
    }

    await this.submitToProxy(form, this.dataset.handle, formData);
  }

  onProxySuccess() {
    const formState = this.#formState;
    const successState = this.#successState;
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
  }

  #resetState() {
    const formState = this.#formState;
    const successState = this.#successState;

    if (successState) successState.hidden = true;

    if (formState) {
      formState.hidden = false;
      const form = formState.querySelector('form');
      if (form) {
        form.reset();
        this.clearFormError(form);
        this.clearFieldErrors(this.errorScope(form));
      }
    }
  }
}

if (!customElements.get('out-of-stock-buttons-component')) {
  customElements.define('out-of-stock-buttons-component', OutOfStockButtonsComponent);
}
